var map = {
	"./audio.png": "e423",
	"./doc.png": "09bb",
	"./docx.png": "208b",
	"./excel.png": "184a",
	"./null.png": "9b3a",
	"./pdf copy.png": "c116",
	"./pdf.png": "ef21",
	"./txt.png": "4e98",
	"./video.png": "a6dd",
	"./word.png": "74fe",
	"./xls.png": "7c73",
	"./xlsx.png": "5a53"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c500";